<template>
  <div>
    <g-signin-button
      :params="googleSignInParams"
      @success="onSignInSuccess"
      @error="onSignInError"
    >
      <ui-button color="google" icon="google">
        {{ label() }}
      </ui-button>
    </g-signin-button>
  </div>
</template>

<script>
import UiButton from "@/components/ui/UiButton.vue";
import fetchAPI from "@/mixins/fetchApi";
import UserStore from "@/store/userStore";
export default {
  data() {
    return {
      /**
       * The Auth2 parameters, as seen on
       * https://developers.google.com/identity/sign-in/web/reference#gapiauth2initparams.
       * As the very least, a valid client_id must present.
       * @type {Object}
       */
      googleSignInParams: {
        client_id:
          "649213685263-ufog28bg8ktod6iusjohllu8d1ot3jhv.apps.googleusercontent.com"
      },
      loading: false
    };
  },
  computed: {},
  components: { UiButton },
  mounted() {},
  methods: {
    label() {
      return this.$slots.default
        ? this.$slots.default[0].text
        : "Se connecter avec Google";
    },
    async onSignInSuccess(googleUser) {
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users
      this.loading = true;
      const profile = googleUser.getBasicProfile();
      const id_token = googleUser.getAuthResponse().id_token;
      const response = await fetchAPI.auth("google", {
        name: profile.getName(),
        first_name: profile.getGivenName(),
        last_name: profile.getFamilyName(),
        email: profile.getEmail(),
        username: profile.getName(),
        google: profile,
        id_token: id_token,
        image_url: profile.getImageUrl()
      });
      if (response.statusText == "OK" || response.status === 200) {
        UserStore.commit("signOut");
        UserStore.commit("setUserData", response.data);
        UserStore.commit("setLogged", true);
        UserStore.commit("saveLocalStorage");
        fetchAPI.setAxiosHeaders();
        this.$emit("success");
      } else {
        this.$emit("error", response);
        this.loginError = response.data.message;
      }
      this.loading = false;
    },
    onSignInError(error) {
      this.$emit("error", error);
    }
  }
};
</script>
